module.exports = __webpack_public_path__ + "static/media/img-benefit-1.0df9249e.svg";